module.exports = __webpack_public_path__ + "img/1.53d90070.jpg";